import { Project } from './../project';
import { ProjectsService } from './api-services/projects.service';
import { RouteService } from 'app/model/services/route.service';
import { Feature } from 'app/model/mapping/drawing/Feature';
// import { RouteFeature } from './../../types/route-data';
import { Injectable } from '@angular/core';
import { Route } from 'app/types/route-data';
import { ObjID } from '../id-manager';
import { SubMode } from 'app/components/reports/reports.component';

@Injectable({
  providedIn: 'root'
})
export class CostReportService {

  public lastReport: Array<any> = [];
  public matchedRoutes: any;
  public lastLength: number = 0;
  private _state: 'ready' | 'building' = 'ready';
  public get state(): 'ready' | 'building' {
    return this._state;
  }
  constructor(private routeSvc: RouteService) { }

  MakeReport(route: Route, mode: SubMode, length: number = 0): Array<any> {
    this.matchedRoutes = {};
    this.lastLength = 0;
    return this.Report(route, mode);
  }
  Report(route: Route, mode: SubMode, length: number = 0): Array<any> {
    if (length === 0) this.lastLength = 0;
    const routeFeature: any = route.feature as any;
    const segs: Array<any> = routeFeature.segments;
    const points = routeFeature.points;
    const records: Array<any> = [];
    const matches: any = {};
    const matchedRoutes: any = this.matchedRoutes;
    if (!segs || (segs?.length === 0)) {
      if (!!points && points.length) {
        return points[0];
      }
      this.lastReport = [];
      return [];
    }
    for (const seg of segs) {
      if (!matches[seg.from.id]) {
        matches[seg.from.id] = true;
        records.push(seg.from as any);
      }
      if (!matches[seg.id]) {
        matches[seg.id] = true;
        records.push(seg as any);
        length = seg.length;
      }
      if (!matches[seg.to.id]) {
        matches[seg.to.id] = true;
        records.push(seg.to as any);
      }
    }

    matchedRoutes[route.id] = true;
    if (mode === '*+') {
      const response = this.MergeChildren(records, route, matchedRoutes, matches, length, mode);
      length += response.len;
    }
    this.lastReport = records;
    this.lastLength = length;
    this.matchedRoutes = matchedRoutes;

    return records;
  }
  MergeChildren(records: Array<any>, route: Route, matchedRoutes: any, matches: any, length: number, mode: SubMode): { len: number } {
    if (route.hasChildren) {
      for (const routeChild of route.children!) {
        if (matchedRoutes[routeChild] === true) { continue; }
        const child = this.routeSvc.GetRoute(routeChild as number);
        const report = this.Report(child as Route, mode);
        for (const entry of report) {
          if (matches[entry.id]) continue;
          records.push(entry);
        }
        matchedRoutes[routeChild] = true;
        /*if (child.hasChildren) {
          this.MergeChildren(records, route, matches, matchedRoutes, length, mode);
        }*/
      }
    }
    return { len: length }

  }

}
